<script>
//import * as AmazonCognitoIdentity from "amazon-cognito-identity-js"
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails
} from "amazon-cognito-identity-js"
import awsConfiguration from "../awsConfiguration";
import ApiConfig from "../apis/ApiConfig";
export default {
    data: () => ({
    }),
    computed: {
        cognitoUserPool(){
            return this.$store.state.cognito.userPool
        },
        // cognitoへのサインインが完了しているかを示す
        isAuthenticated(){
            return this.$store.state.currentUser.authenticated;
        },
        userProfile(){
          return this.$store.state.userProfile
        },
        // 仕入先データベースへのサインイン状態を示す
        isApplicationSigned(){
          return !!this.$store.state.userProfile.name;
        }
    },
    methods: {

        initCognito(){
            this.$store.commit('setUserPool', this._makeCognitoUserPool());
        },

        // cognitoにサインインを試行します
        cognitoSignIn(userName,password){

            console.log("Try cognitoSignIn " + userName)

            const authenticationDetails = new AuthenticationDetails({
                Username : userName,
                Password : password
            })

            const cognitoUser = new CognitoUser({
                Username: userName,
                Pool: this.cognitoUserPool
            })

            return Promise.resolve()
                .then(a => this._cognitoAuthenticateUser(authenticationDetails,cognitoUser))
                .then(authUser => {
                    console.log('cognito authenticate result: ')
                    console.log(authUser)
                    if (authUser.challengeName === "NEW_PASSWORD_REQUIRED"){
                        // 初回ログイン時は、必ずパスワードを再設定するように求めてくる
                        // 新しいパスワードは同じでも構わないので、completeNewPasswordに同じパスワードを渡してしまう
                        return this._completeNewPasswordChallenge(authUser,password)
                    } else {
                        return authUser
                    }
                })
                .then(result => {
                    console.log('cognito authenticate sequence result: ')
                    console.log(result)

                    const accessToken = result.getAccessToken().getJwtToken()
                    console.log('AccessToken: ' + accessToken)
                    ApiConfig.authCode = accessToken; // API実行用にaccessTokenを保存しておく

                    this.$store.commit('setCurrentUser', accessToken); // ここに何を保存するか要確認
                })
                .catch(err => {
                    console.log("ログインに失敗しました。")
                    console.error(err)
                    let errCode = err.code
                    if (errCode === "UserNotFoundException"){
                        console.log("ユーザIDが存在しません。")
                    }
                    else if (errCode === "NotAuthorizedException"){
                        console.log("パスワードが異なります。")
                    }
                })


        },

        // cognitoからサインアウト
        cognitoSignOut(){
            const cognitoUser = this.cognitoUserPool.getCurrentUser()
            if (cognitoUser){
                cognitoUser.signOut()
                //localStorage.clear()
                ApiConfig.authCode = "";
                this.$store.commit('setCurrentUser', null);
            }
        },

        checkCognitoSession(){

            return new Promise((resolve,reject) => {

                const cognitoUser = this.cognitoUserPool.getCurrentUser()
                if (cognitoUser){
                    cognitoUser.getSession(function(err, sesResult) {
                        if (sesResult){
                            console.log("ログインしているみたいです。result:")
                            console.log(sesResult)

                            let accessToken = sesResult.accessToken.jwtToken;
                            let expiredTime = sesResult.accessToken.payload.exp;
                            let dateTime = new Date(expiredTime * 1000);
                            console.log("有効期限：" + dateTime.toLocaleTimeString());

                            ApiConfig.authCode = accessToken; // API実行用にaccessTokenを保存しておく

                            resolve(sesResult)
                        }
                        else {
                            console.log("ログインされてません。 getSession.result is " + sesResult)
                            reject("ログインされてません。 getSession.result is " + sesResult);
                        }
                    });
                } else {
                    console.log("ログインされてません。 CurrentUser is nothing.")
                    reject("ログインされてません。 CurrentUser is nothing.");
                }

            });


        },


        /*
        // 仕入先データベースへのログインを行う
        // cognitoへのログインが完了してから実行すべし
        applicationSignIn(){
          return new Promise((resolve,reject) => {
            let prof = {
              name:"テストユーザ",
              userId:1,
            }
            this.$store.commit('setProfile', prof);
            window.logger.info("プロフィールを設定。",prof)
            resolve(true)
          })
        },
        */

        _makeCognitoUserPool(){
            return new CognitoUserPool({
                UserPoolId: awsConfiguration.UserPoolId,
                ClientId: awsConfiguration.ClientId,
            });
        },

        _cognitoAuthenticateUser(authenticationDetails,cognitoUser){
            return new Promise((resolve,reject) => {
                cognitoUser.authenticateUser(authenticationDetails, {
                    onSuccess: (result) => {
                        resolve(result)
                    },
                    onFailure: (err) => {
                        reject(err)
                    }
                })
            })
        },

        _completeNewPasswordChallenge(cognitoUser,password){
            return new Promise((resolve,reject) => {
                cognitoUser.completeNewPasswordChallenge(password, {}, {
                    onSuccess: (result) => {
                        resolve(result)
                    },
                    onFailure: (err) => {
                        reject(err)
                    }
                })
            })
        }

    },
}
</script>